import { HighlightTextStoryblok } from '../types/generated-storyblok';

interface ContentBlockHighlightProps {
  blok: HighlightTextStoryblok;
}

export const ContentBlockHighlight = ({ blok }: ContentBlockHighlightProps) => (
  <div className="mx-auto flex w-full max-w-2xl flex-col space-y-3 text-center">
    <p className="text-md md:text-lg">{blok.text}</p>
    {blok.author && <span className="text-neutral-4">{blok.author}</span>}
  </div>
);
